import React from 'react';
import { Navigate, Route, Routes, Outlet } from 'react-router-dom';

import { Onboarding } from '../Onboarding/Onboarding';
import { PersonalAccount } from '../PersonalAccount/PersonalAccount';
import Login from '../Login';
import MainLayout from '../../layouts/main';
import AuthLayout from '../../layouts/auth';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../LoadingSpinner';
import SignUp from '../SignUp';

const PrivateRoute = () => {
  const { isAuthenticated, activeProfile, isInitialized } = useAuth();

  if (!isInitialized) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated && !activeProfile) {
    return <Navigate to="/login" replace />;
  }

  if (!activeProfile) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
};

const PublicRoute = () => {
  const { isAuthenticated, activeProfile, isInitialized, loading } = useAuth();

  if (!isInitialized || loading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated && activeProfile) {
    return <Navigate to="/" replace />;
  }

  if (isAuthenticated && !activeProfile) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
};

const OnboardingRoute = () => {
  const { isAuthenticated, activeProfile, isInitialized } = useAuth();

  if (!isInitialized) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (activeProfile) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
        </Route>
      </Route>
      <Route element={<OnboardingRoute />}>
        <Route element={<AuthLayout />}>
          <Route path="/onboarding" element={<Onboarding />} />
        </Route>
      </Route>
      <Route element={<PrivateRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/" element={<PersonalAccount />} />
        </Route>
      </Route>
    </Routes>
  );
}
